import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { Box, Grid, Typography } from "@material-ui/core"
import { BasicTable } from "../../common/Table"
import UserReviewTabularView from "../UserReviewOverview/TabularView"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { setDashboardReview } from "../../../actions/dashboardActions"
import { roles } from "../../../data/roles"

const useStyles = makeStyles((theme) => ({
	reviewOverviewTable: {
		maxHeight: "300px",
		"& .MuiTableCell-root": {
			borderBottom: `1px ${theme.typography.button.disabledColor} solid`,
		},
	},
	reviewName: {
		cursor: "pointer",
		textDecoration: "none",
		"&:hover": {
			textDecoration: "underline",
		},
	},
	reviewOverviewBox: {
		border: `1px ${theme.typography.button.disabledColor} solid`,
		borderRadius: 3,
		marginTop: 10,
	},
}))

function TabularView({ getUserReviewDetails }) {
	const [t] = useTranslation("global")
	const dispatch = useDispatch()
	const theme = useTheme()
	const classes = useStyles()
	const review_overview = useSelector((state) => state?.info?.reviewOverviewDetails?.review_overview)
	const reviewList = useSelector((state) => state.review?.allReviewlist)
	const isReviewOverviewLoading = useSelector((state) => state?.info?.isReviewOverviewLoading)
	const selectedReview = useSelector((state) => state.dashboard?.selectedReview)
	const isCaseUser = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Case_User)
	const isCaseAdmin = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Case_Administrator)

	const handleReviewNameClick = (reviewId) => {
		if (reviewList?.length > 0 && reviewId) {
			const selectedReview = reviewList?.find((item) => item?.id === reviewId)
			getUserReviewDetails(selectedReview?.id)
			dispatch(setDashboardReview(selectedReview))
		}
	}

	const getReviewName = (params) => {
		return (
			<Typography className={classes.reviewName} component="a" onClick={() => handleReviewNameClick(params?.row?.review_id)} noWrap>
				{params?.row?.name}
			</Typography>
		)
	}

	const getColumns = () => {
		if (isCaseUser && !isCaseAdmin) {
			return [
				{
					field: "name",
					headerName: t("dashboard.reviewOverviewTable.reviewName"),
					sortable: false,
					flex: 1,
					renderCell: getReviewName,
				},
				{
					field: "creation_time",
					headerName: t("dashboard.reviewOverviewTable.createdDate"),
					sortable: false,
					flex: 1,
				},
				{
					field: "due_date",
					headerName: t("dashboard.reviewOverviewTable.dueDate"),
					sortable: false,
					flex: 1,
				},
				{
					field: "assigned",
					headerName: t("dashboard.assignedFiles"),
					sortable: false,
					flex: 1,
				},
				{
					field: "reviewed",
					headerName: t("dashboard.reviewOverviewTable.reviewed"),
					sortable: false,
					flex: 1,
				},
			]
		} else {
			return [
				{
					field: "name",
					headerName: t("dashboard.reviewOverviewTable.reviewName"),
					sortable: false,
					flex: 1,
					renderCell: getReviewName,
				},
				{
					field: "creation_time",
					headerName: t("dashboard.reviewOverviewTable.createdDate"),
					sortable: false,
					flex: 1,
				},
				{
					field: "due_date",
					headerName: t("dashboard.reviewOverviewTable.dueDate"),
					sortable: false,
					flex: 1,
				},
				{
					field: "total",
					headerName: t("dashboard.reviewOverviewTable.total"),
					sortable: false,
					flex: 1,
				},
				{
					field: "reviewed",
					headerName: t("dashboard.reviewOverviewTable.reviewed"),
					sortable: false,
					flex: 1,
				},
				{
					field: "unassigned",
					headerName: t("dashboard.reviewOverviewTable.unassigned"),
					sortable: false,
					flex: 1,
				},
			]
		}
	}

	const getRows = () => {
		if (review_overview?.length > 0) {
			return review_overview?.map((review) => ({ ...review, selected: selectedReview?.id === review?.review_id }))
		}
		return []
	}

	return (
		<Box className={classes.reviewOverviewBox}>
			<BasicTable
				columns={getColumns()}
				rows={getRows()}
				isLoading={isReviewOverviewLoading}
				pageInfo={{
					page: 1,
					pageSize: getRows()?.length,
					rowsPerPageOptions: [5, 10, 20, 50],
					totalRowCount: getRows()?.length,
					paginationMode: "server",
					handlePageChange: () => {},
					handlePageSizeChange: () => {},
				}}
				showPagination={false}
				sortInfo={{
					sortingMode: "server",
					sortModel: [],
					onSortModelChange: () => {},
				}}
				checkboxSelection={false}
				footerInfo={{
					hideFooter: false,
					hideSelectionCount: true,
					hidePagination: true,
				}}
				topBarInfo={{
					show: true,
					rightSection: "",
				}}
				totalCountText={`${t("dashboard.reviewOverviewTable.totalReview")} ${getRows()?.length}`}
				showDownloadButton={false}
				showColumnsButton={false}
				customClass={classes.reviewOverviewTable}
				customCellPadding="16px"
			/>
		</Box>
	)
}

export default TabularView
